import { MenuType, MenuItem } from 'viasng-core';
const MenuItems: MenuItem[] = [];
// Departmanlar
MenuItems.push({
    name: 'moduleNames.module_1200',
    type: MenuType.title,
    children: [
        {
            // Supply
            name: 'moduleNames.module_1000',
            icon: 'checklist_rtl',
            type: MenuType.sub,
            children: [
                { pageId: 1050, url: '/repair-marketing/list-vessel-tender', type: MenuType.link }
            ]
        },
        {
            // Spare Yedek Parça
            name: 'moduleNames.module_1100',
            icon: 'settings_suggest',
            type: MenuType.sub,
            children: [
                { pageId: 1150, url: '/repair-marketing/list-vessel-tender-spare', type: MenuType.link }
            ]
        },
        {
            // Servis Yedek Parça
            name: 'moduleNames.module_1350',
            icon: 'sailing',
            type: MenuType.sub,
            children: [
                { pageId: 1350, url: '/repair-marketing/list-vessel-tender-service', type: MenuType.link },
                { pageId: 4100, url: '/planning/list-contractors', type: MenuType.link }
            ]
        },
        // {
        //     // Özel Projeler
        //     name: 'moduleNames.module_15000',
        //     icon: 'grade',
        //     type: MenuType.sub,
        //     children: [
        //         { pageId: 15000, url: '/repair-marketing/list-vessel-tender-special', type: MenuType.link }
        //     ]
        // },
        {
            name: 'moduleNames.module_1300',
            icon: 'support_agent',
            type: MenuType.sub,
            children: [
                { pageId: 1400, url: '/repair-marketing/list-vessel', type: MenuType.link },
                { pageId: 1000, url: '/repair-marketing/list-companies', type: MenuType.link },
                { pageId: 1419, url: '/repair-marketing/list-vessel-type', type: MenuType.link },
                { pageId: 1550, url: '/repair-marketing/list-ports', type: MenuType.link }
            ]
        },
        {
            // Pazarlama
            name: 'files',
            icon: 'picture_as_pdf',
            type: MenuType.sub,
            children: [
                { pageId: 215, url: '/repair-marketing/marketing-files', type: MenuType.link }
            ]
        }
    ]
});
/* Satış */
MenuItems.push({
    name: 'moduleNames.module_2850',
    type: MenuType.title,
    children: [
        {
            // SIPARIS
            name: 'moduleNames.module_2850',
            icon: 'point_of_sale',
            type: MenuType.sub,
            children: [
                { pageId: 2850, type: MenuType.link, url: '/sale/list-sale-order' }
            ]
        },
    ]
});
/*Satınalma Fişleri
    Talep
    ..
    Sipariş
    ..
*/
MenuItems.push({
    name: 'moduleNames.module_2000',
    type: MenuType.title,
    children: [
        {
            // TALEP
            name: 'otokomplate',
            icon: 'shopping_cart',
            type: MenuType.sub,
            children: [
                { url: '/hr/test-auto', type: MenuType.link }
            ]
        },
        {
            // TALEP
            name: 'moduleNames.module_2400',
            icon: 'shopping_cart',
            type: MenuType.sub,
            children: [
                { pageId: 2400, url: '/purchasing/list-request', type: MenuType.link },
                { pageId: 2404, url: '/purchasing/list-new-request', type: MenuType.link }
            ]
        },
        {
            // TEKLIF
            name: 'moduleNames.module_2500',
            icon: 'post_add',
            type: MenuType.sub,
            children: [
                { pageId: 2500, type: MenuType.link, url: '/purchasing/list-tenders' },
                { pageId: 2516, type: MenuType.link, url: '/purchasing/list-approval-tenders' },
                { pageId: 2515, type: MenuType.link, url: '/purchasing/list-approved-tenders' },
                { pageId: 2517, type: MenuType.link, url: '/purchasing/list-department-tenders' }
            ]
        },
        {
            // SIPARIS
            name: 'moduleNames.module_2800',
            icon: 'add_shopping_cart',
            type: MenuType.sub,
            children: [
                { pageId: 2800, type: MenuType.link, url: '/purchasing/list-order' },
                { pageId: 102800, type: MenuType.link, url: '/purchasing/purchase-order-report' }
            ]
        },
       
        {
            // TEDARIKCI
            name: 'moduleNames.module_2600',
            icon: 'storefront',
            type: MenuType.sub,
            children: [
                { pageId: 2600, type: MenuType.link, url: '/purchasing/list-suppliers' }
            ]
        },

    ]
});
//HR MODULE
MenuItems.push({
    name: 'moduleNames.module_21000',
    type: MenuType.title,
    children: [{
        name: 'moduleNames.module_21000',
        icon: 'group',
        type: MenuType.sub,
        children: [
            { pageId: 220, url: '/hr/list-department', type: MenuType.link },
            { pageId: 240, url: '/hr/list-position', type: MenuType.link },
            { pageId: 130, url: '/hr/list-users', type: MenuType.link },
            { pageId: 14550, url: '/maintenance/list-project-status', type: MenuType.link },
        ]
    }]
});
//Raporlar
MenuItems.push({
    name: 'moduleNames.module_100000',
    type: MenuType.title,
    children: [{
        name: 'moduleNames.module_100000',
        icon: 'list',
        type: MenuType.sub,
        children: [
            { pageId: 1417, type: MenuType.link, url: '/repair-marketing/time-report' },
            { pageId: 2842, type: MenuType.link, url: '/repair-marketing/annual-orders' },
            { pageId: 2843, type: MenuType.link, url: '/repair-marketing/annual_offer_order_discount_rate' },
            { pageId: 1434,  type: MenuType.link, url: '/repair-marketing/time_between_two_dates' },
            { pageId: 1439,  type: MenuType.link, url: '/repair-marketing/time_between_two_dates_procurement' },
            { pageId: 102900,  type: MenuType.link, url: '/purchasing/report-project-orders' }
        ]
    }]
});

//Malzeme Yönetimi
MenuItems.push({
    name: 'moduleNames.module_2050',
    type: MenuType.title,
    children: [{
        name: 'moduleNames.module_2050',
        icon: 'settings_applications',
        type: MenuType.sub,
        children: [
            { pageId: 2000, type: MenuType.link, url: '/purchasing/list-material' },
            { pageId: 2100, type: MenuType.link, url: '/purchasing/list-material-group' },
            { pageId: 2106, type: MenuType.link, url: '/purchasing/list-material-subgroup' },
            { pageId: 2050, type: MenuType.link, url: '/purchasing/list-services' },
        ]
    }]
});
// WAREHOUSE MODULE
MenuItems.push({
    name: 'moduleNames.module_3000',
    type: MenuType.title,
    children: [{
        name: 'moduleNames.module_3000',
        icon: 'local_offer',
        type: MenuType.sub,
        children: [
            // { pageId: 3201, url: '/warehouse/material-count', type: MenuType.link },
            // { pageId: 3200, url: '/warehouse/list-material-count', type: MenuType.link },
            { pageId: 3000, url: '/warehouse/list-warehouse-intakes', type: MenuType.link },
            { pageId: 3100, url: '/warehouse/list-warehouse-withdraws', type: MenuType.link },
            { pageId: 2809, url: '/warehouse/list-order', type: MenuType.link },
            // { pageId: 3500, url: '/warehouse/list-warehouse-tansfers', type: MenuType.link },
            // { pageId: 3450, url: '/warehouse/list-warehouse-return-equipment', type: MenuType.link },
            // { pageId: 3400, url: '/warehouse/list-warehouse-withdraw-equipment', type: MenuType.link },
            // { pageId: 3470, url: '/warehouse/list-equipment-repair-return', type: MenuType.link },
            { pageId: 3650, url: '/warehouse/list-project-return', type: MenuType.link }
        ]
    }]
});
export { MenuItems };
